<div class="wp-wrapper">
  <p-accordion class="w-full">
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="details dis-flex flex-sb w-full">
          <div class="tags m-b-15">
            <div class="dis-flex">
              <p-chip
                class="theme"
                [ngbTooltip]="wpList?.theme?.value"
                *ngIf="wpList?.theme?.value"
              >
                <span
                  *ngIf="wpList?.theme?.value"
                  class="theme-color"
                  [style]="{ background: wpList?.theme?.color }"
                ></span>
                <span
                  class="title b3 text-80 lh-2-0"
                  *ngIf="wpList?.theme?.value"
                >
                  {{ wpList?.theme?.value }}
                </span>
              </p-chip>
              <p-divider
                class="vertical-divider"
                layout="vertical"
                *ngIf="wpList?.theme?.value"
              />
              <p-chip
                class="b3 radius-8 status-chip not-started"
                *ngIf="wpList?.status == '1'"
                label="Not started"
              />
              <p-chip
                class="b3 radius-8 status-chip ongoing"
                *ngIf="wpList?.status == '2'"
                label="Ongoing"
              />
              <p-chip
                class="b3 radius-8 status-chip completed"
                *ngIf="wpList?.status == '3'"
                label="Closed"
              />
              <p-chip
                class="b3 radius-8 status-chip terminated"
                *ngIf="wpList?.status == '4'"
                label="Rejected"
              />

              <!-- display the below DIV only when new work package is created until is approved by the owner's manager -->
              <div class="dis-flex" *ngIf="wpList?.is_approved == '0'">
                <p-divider class="vertical-divider" layout="vertical" />
                <div class="approval-pending-tag p-t-3 p-b-4 p-r-10 p-l-20">
                  <p class="b3 text-error m-b-0 lh-2-0">Approval Pending</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-title wd-90">
          <p class="b1 text-90 m-b-0">
            {{ wpList?.name }}
          </p>
        </div>
      </ng-template>
      <div>
        <div class="description m-b-10 dis-flex flex-sb">
          <div class="b3 text-60">
            (Description: {{ wpList?.description || "" }})
          </div>
          <div class="action-items p-t-4">
            <ng-icon
              *ngIf="onGoingTaskMemberLists?.length"
              class="wp-working-members m-r-15"
              name="hugeInformationCircle"
              ngbTooltip="View Working Members"
              [ngbPopover]="membersWorkingOnWP"
            />
            <button
              *ngIf="
                wpList?.status != 0 && wpList?.members
                  | filterByPlace : 'owner'
                  | isOwner : userData?.user_id
              "
              class="icon-only-btn pointer-cursor"
              [ngbPopover]="actionItemsMenu"
              ngbTooltip="Action Items"
            >
              <ng-icon
                class="icon-hover-primary"
                name="hugeMoreVerticalCircle01"
              />
            </button>
            <ng-template #membersWorkingOnWP>
              <div class="m-b-10 p-t-5 p-r-0 p-b-5 p-l-10 bg-text-20">
                <p class="b3 m-b-0">Following are currently working on:</p>
              </div>
              <div class="dis-flex flex-row">
                <div
                  class="dis-flex flex-m m-b-8 m-l-10"
                  *ngFor="let member of onGoingTaskMemberLists"
                >
                  <p-avatar
                    class="outcome-dependency-avatar m-r-5 p-avatar-square"
                    [image]="member.user.avatar || helper.defaultImageUrl"
                  />

                  <div class="dependency-person">
                    <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                      {{ member.user.name }}
                    </p>
                    <p class="b3 text-60 m-b-0 lh-1-5">
                      {{ member.user.designation }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="dis-flex flex-row">
                <div class="dis-flex flex-m m-b-8 m-l-10">
                  <p-avatar
                    class="outcome-dependency-avatar m-r-5"
                    image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
                    shape="circle"
                  />
                  <div class="dependency-person">
                    <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                      Romy Murray
                    </p>
                    <p class="b3 text-60 m-b-0 lh-1-5">CRO Associate</p>
                  </div>
                </div>
                <div class="dis-flex flex-m m-b-8 m-l-10">
                  <p-avatar
                    class="outcome-dependency-avatar m-r-5"
                    image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
                    shape="circle"
                  />
                  <div class="dependency-person">
                    <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                      Romy Murray
                    </p>
                    <p class="b3 text-60 m-b-0 lh-1-5">CRO Associate</p>
                  </div>
                </div>
              </div> -->
            </ng-template>

            <ng-template #actionItemsMenu>
              <div class="action-item-list">
                <a
                  type="button"
                  *ngIf="
                    wpList?.members
                      | filterByPlace : 'owner'
                      | isOwner : userData?.user_id
                  "
                  class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
                  (click)="updateWorkPackage()"
                >
                  <ng-icon class="text-80 lh-1-0" name="hugeEdit02" size="18" />
                  <span class="b2 text-80 m-l-10">Edit / Update</span>
                </a>
                <a
                  *ngIf="
                    (wpList?.members | isMember : userData?.user_id) &&
                    wpList?.is_approved == 1
                  "
                  type="button"
                  class="dis-flex p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
                  (click)="showQuarterlyOutcomes()"
                >
                  <ng-icon
                    class="text-80 lh-1-0"
                    [name]="!quarterlyOutcomes ? 'hugeView' : 'hugeViewOff'"
                    size="18"
                  />
                  <span class="b2 text-80 m-l-10">{{
                    !quarterlyOutcomes
                      ? "View Short Term Outcomes"
                      : "Hide Short Term Outcomes"
                  }}</span>
                </a>
                <a
                  *ngIf="
                    (wpList?.members
                      | filterByPlace : 'owner'
                      | isOwner : userData?.user_id) &&
                    [1, 2]?.includes(wpList?.status) &&
                    wpList?.is_approved == 1
                  "
                  type="button"
                  class="dis-flex success-action-item p-t-12 p-b-12 p-l-20 p-r-20 trans-0-4"
                  (click)="createSummary()"
                >
                  <ng-icon
                    class="text-80 lh-1-0"
                    name="hugeCheckmarkCircle04"
                    size="18"
                  />
                  <span class="b2 text-80 m-l-10">Mark as Closed</span>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="wp-content dis-flex flex-row flex-sb">
          <div class="dis-flex">
            <div>
              <p class="field-title caption text-60 m-b-0">Area of Impact</p>
              <p class="b3 font-medium text-80 m-b-0">
                {{ (wpList?.area_of_impact | titlecase) || "NA" }}
              </p>
            </div>
            <p-divider class="vertical-divider" layout="vertical" />
            <div class="dis-flex">
              <div
                class="m-r-20"
                *ngFor="let owner of wpList?.members | filterByPlace : 'owner'"
              >
                <p class="field-title caption text-60 m-b-0">Owner</p>
                <p-avatar
                  class="p-avatar-square"
                  [image]="owner.detail.avatar || helper.defaultImageUrl"
                  [ngbTooltip]="owner.detail.name"
                />
              </div>
              <div>
                <p
                  class="field-title caption text-60 m-b-0"
                  *ngIf="visibleMembers?.length"
                >
                  Members
                </p>
                <p-avatarGroup>
                  <p-avatar
                    class="p-avatar-square"
                    *ngFor="let member of visibleMembers"
                    [image]="member.detail.avatar || helper.defaultImageUrl"
                    [ngbTooltip]="member.detail.name"
                  ></p-avatar>

                  <p-avatar
                    *ngIf="extraMembers.length > 0"
                    type="button"
                    class="avatar-count p-avatar-square"
                    [label]="'+' + extraMembers.length"
                    [ngbPopover]="membersPopover"
                    popoverClass="avatar-group-popover"
                  ></p-avatar>
                  <!-- <ng-template #members>
                    <div class="dis-flex flex-m m-b-8">
                      <p-avatar
                        class="outcome-dependency-avatar m-r-5"
                        image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
                        shape="circle"
                      />
                      <div class="dependency-person">
                        <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                          Romy Murray
                        </p>
                        <p class="b3 text-60 m-b-0 lh-1-5">CRO Associate</p>
                      </div>
                    </div>
                    <div class="dis-flex flex-m m-b-8">
                      <p-avatar
                        class="outcome-dependency-avatar m-r-5"
                        image="https://primefaces.org/cdn/primeng/images/demo/avatar/ionibowcher.png"
                        shape="circle"
                      />
                      <div class="dependency-person">
                        <p class="b3 font-medium text-100 m-b-0 lh-1-5">
                          Romy Murray
                        </p>
                        <p class="b3 text-60 m-b-0 lh-1-5">CRO Associate</p>
                      </div>
                    </div>
                  </ng-template> -->

                  <ng-template #membersPopover>
                    <div *ngFor="let member of extraMembers" class="">
                      <div class="">
                        <p-avatar
                          class="outcome-dependency-avatar p-avatar-square m-r-5"
                          [image]="
                            member.detail.avatar || helper.defaultImageUrl
                          "
                        ></p-avatar>
                        <div class="dependency-person">
                          <p
                            class="b3 font-medium text-100 m-b-0 lh-1-5 of-hidden text-overflow space-nowrap"
                            ngbTooltip="{{ member.detail.name }}"
                          >
                            {{ member.detail.name }}
                          </p>
                          <p
                            class="b3 text-60 m-b-0 lh-1-5 of-hidden text-overflow space-nowrap"
                            ngbTooltip="{{
                              member.detail.designation || 'N/A'
                            }}"
                          >
                            {{ member.detail.designation || "N/A" }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-avatarGroup>
              </div>
            </div>
          </div>
          <div class="dis-flex">
            <button
              *ngIf="wpList?.status == '3' && wpList?.is_approved == 1"
              class="btn wp-download-btn b2 m-r-10 wd-150px"
              (click)="viewSummary()"
            >
              <ng-icon
                class="lh-1-0 text-primary m-r-5"
                name="hugeView"
                size="16"
              />
              View Summary
            </button>
            <button
              *ngIf="wpList?.files?.length && wpList?.is_approved == 1"
              class="btn wp-download-btn b2 wd-150px"
              (click)="showAttachment()"
            >
              <ng-icon
                class="lh-1-0 text-primary m-r-5"
                name="hugeDownload03"
                size="16"
              />
              View Downloads
            </button>
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

  <div
    class="quarterly-outcome-list p-t-10 p-b-10 p-l-10 p-r-10"
    *ngIf="quarterlyOutcomes"
  >
    <ng-container *ngIf="quarterlyOutcomesLists?.length; else noDataFound">
      <app-quarterly-outcome
        *ngIf="quarterlyOutcomesLists?.length; else loadingData"
        [isWorkPackage]="isWorkPackage"
        [quarterlyOutcomesLists]="quarterlyOutcomesLists"
      ></app-quarterly-outcome>
    </ng-container>
    <!-- <app-milestone></app-milestone> -->
  </div>
</div>
<ng-template #noDataFound>
  <p class="no-quartely-table">No Short Term Outcomes available.</p>
</ng-template>
<ng-template #loadingData>
  <app-shimmer-list></app-shimmer-list>
</ng-template>
<!-- Work Package Summary Modal -->
<p-dialog
  [header]="showSummaryTitle"
  class="action-item-modal b1 font-medium"
  [modal]="true"
  [(visible)]="wpSummaryModal"
  [style]="{ width: '70rem' }"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <div class="row">
      <div class="col-md-12">
        <div class="dis-flex flex-col">
          <label class="b3 text-90">Work Package</label>
          <div
            class="border-20 radius-8 bg-text-10 p-t-12 p-b-12 p-l-16 p-r-16"
          >
            <p class="b1 text-90 m-b-0">{{ wpList?.name }}</p>
            <p class="b3 text-60 m-b-0">
              (Description:{{ wpList?.description }})
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-t-10">
      <div class="col-md-12">
        <div class="dis-flex flex-col">
          <div class="d-flex">
            <label class="b3 text-90"
              >Summary <span class="mandatory">*</span></label
            >
            <div
              *ngIf="summary.invalid && summary.touched"
              class="error-message"
            >
              Summary is required.
            </div>
          </div>
          <textarea
            class="b3 text-90"
            rows="5"
            cols="30"
            [disabled]="viewMode"
            name="summary"
            #summary="ngModel"
            required
            [(ngModel)]="summaryText"
            placeholder="Enter summary here"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <div
    class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15"
    *ngIf="!viewMode"
  >
    <button class="btn outline wd-100px m-r-10" (click)="closeSummaryDialog()">
      Cancel
    </button>
    <button class="btn primary wd-100px" (click)="submitSummary()">Done</button>
  </div>
</p-dialog>

<!-- Edit / Update Work Package Modal -->
<div *ngIf="wpWorkPackage">
  <p-dialog
    header="Edit / Update"
    class="action-item-modal b1 font-medium"
    [modal]="true"
    [(visible)]="wpWorkPackage"
    [style]="{ width: '70rem' }"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
      <app-wp-form
        [wpList]="wpList"
        [businessThemeLists]="businessThemeLists"
        [brandLists]="brandLists"
        [teamMembersLists]="teamMembersLists"
        [editData]="wpList"
        [userData]="userData"
        [isEditMode]="isEditMode"
        (updateFormWP)="updateFormWP.emit($event)"
        (wpFormModal)="closeModal($event)"
      ></app-wp-form>
    </div>
    <!-- <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
      <button class="btn outline wd-100px m-r-10">Cancel</button>
      <button class="btn primary wd-100px">Done</button>
    </div> -->
  </p-dialog>

  <!-- Attachment Modal -->

  <!-- <p-dialog  *ngIf="attachmentModal"
    header="View Downloads"
    class="action-item-modal b1 font-medium"
    [modal]="true"
    [(visible)]="attachmentModal"
    [style]="{ width: '30rem' }"
    [baseZIndex]="9999"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
      <div
        class="dis-flex flex-sb-m flex-m m-b-15"
        *ngFor="let file of wpList?.files"
      >
        <div>
          <p class="b2 text-90 m-b-0">{{ file?.name }}</p>
        </div>
        <div>
          <button class="btn outline primary" (click)="downloadFile(file)">
            Download
          </button>
        </div>
      </div>
    </div>
  </p-dialog> -->
</div>


<app-wp-download-files-modal (closeDownlaodModal)="closeDownlaodModal($event)" [attachmentModal]="attachmentModal" [wpList]="wpList"  *ngIf="attachmentModal" (downloadFile)="downloadFile($event)"></app-wp-download-files-modal >
